export { default as useUniversalFilterCompanyFinCategories } from './useUniversalFilterCompanyFinCategories';
